import type { RequestStatus } from '@features/request/requestSlice';
import { useResetStoreData } from '@features/request/useResetStoreData';
import type { BimcIsCalculationLimitedCostCodeUniqueQueryVariables } from '@gql/graphql';
import type { Meta } from '@utils/types';
import { useRequest } from 'features/request/useRequest';

import type { PayloadAction } from '@reduxjs/toolkit';

import { bimcIsCalculationLimitedCostKeyUniqueGql } from '../bimCalculationLimitedQueries';

const requestId = 'bimcIsCalculationLimitedCostKeyUnique';

export const useBimIsUniqueKeyCalculationLimitedCost = (): {
    isUniqueKey: boolean | null | undefined;
    isUniqueKeyRequest: (
        variables?: BimcIsCalculationLimitedCostCodeUniqueQueryVariables,
        depsUpdater?: () => void,
    ) => PayloadAction;
    isUniqueKeyFetching: RequestStatus;
    resetIsUniqueKeyData: (value: unknown) => { payload: undefined; type: string } & { meta: Meta };
    isUniqueKeySetData: any;
} => {
    const [uniqueData, uniqueDataStatus, , isUniqueKeyRequest, isUniqueKeySetData] = useRequest({
        requestId,
        query: bimcIsCalculationLimitedCostKeyUniqueGql,
        withEffect: false,
    });
    const [resetIsUniqueData] = useResetStoreData({ requestId });

    return {
        isUniqueKey: uniqueData?.bimcIsCalculationLimitedCostCodeUnique?.isUnique,
        isUniqueKeyFetching: uniqueDataStatus,
        isUniqueKeyRequest,
        resetIsUniqueKeyData: resetIsUniqueData,
        isUniqueKeySetData,
    };
};
